import React, { useEffect,useState } from 'react'
import { connect } from 'react-redux'
import { setCurrenttab_Learn } from '../../Actions/Actionexport'

import { Row, Col, Container } from 'reactstrap'

import backgroundimg from '../../Resources/Images/dd.jpg'
import Learncard from '../Learncard'
import unity from '../../Resources/Images/unity-tab-square-black.png'
import reactlogo from '../../Resources/Images/logo-og.png'
import java from '../../Resources/Images/f1eaa7278f64e27128e062a3de918265.png'
import Formmodel from '../Formmodel'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }



const Learn = (props) => {

    const [modelopen,setmodelstate]=useState(false);
    const [course,setcoruse]=useState('');
    const [opensucess, setOpensuccess] = React.useState(false);
    const [openerror, setOpenerror] = React.useState(false);

    useEffect(() => {
        props.setCurrenttab_Learn()
    }, [props])


    const handleClosemessage = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenerror(false);
        setOpensuccess(false);
      };

    return (


        <Container fluid={true}  style={{backgroundImage: "url(" + backgroundimg + ")",height:'100%',width:'100%'}}>
             <Snackbar open={opensucess} autoHideDuration={6000} onClose={handleClosemessage}>
        <Alert onClose={handleClosemessage} severity="success">
          Email sent successfully!
        </Alert>
      </Snackbar>
      <Snackbar open={openerror} autoHideDuration={6000} onClose={handleClosemessage}>
        <Alert onClose={handleClosemessage} severity="error">
          Form submission failed!
        </Alert>
      </Snackbar>
            <Row>
                <Col className='md-5 mt-5' style={{ color: 'black', fontSize: '28px', fontFamily: 'Balsamiq Sans ,  cursive', fontWeight:'bold'}}>
                    Want to learn game developement !
            <br></br>
    want to code !<br></br>
    book my webinar class on weekend apply now </Col>
            </Row>
            <Row   lg='4' xs='1'>
                <Col  lg={{offset:1}} xs={{offset:3}} className=' mt-5'>
                    <Learncard title='Unity'  image={unity} content=' Unity is a game engine used to develope games in C#' setmodelstate={setmodelstate} setcoruse={setcoruse}></Learncard>

                </Col>
                <Col lg={{offset:1}} xs={{offset:3}}  className=' mt-5'>

                <Learncard title='React' image={reactlogo} content='React is a frontend javascript library used to develope webapp' setmodelstate={setmodelstate} setcoruse={setcoruse}></Learncard>

                </Col>
                <Col  lg={{offset:1}} xs={{offset:3}}  className=' mt-5'>
                <Learncard title='Java' image={java} content='Learn java from basic to spring boot ' setmodelstate={setmodelstate} setcoruse={setcoruse}></Learncard>

                </Col>
            </Row>
            <Row className='md-5 mt-5'>
<Col></Col>
                </Row>
         {modelopen&&<Formmodel setOpenerror={setOpenerror} setOpensuccess={setOpensuccess} course={course} setmodelstate={setmodelstate}></Formmodel>}
        </Container>

    )
}

const mapdispatchtomethod = (dispatch) => {
    return {
        setCurrenttab_Learn: () => dispatch(setCurrenttab_Learn())
    }
}
export default connect(null, mapdispatchtomethod)(Learn) 